import { render, staticRenderFns } from "./InfoClienteDialogo.vue?vue&type=template&id=df362e2a"
import script from "./InfoClienteDialogo.vue?vue&type=script&lang=js"
export * from "./InfoClienteDialogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports